import { render } from "./SysRed.vue?vue&type=template&id=0adf7583&scoped=true"
import script from "./SysRed.vue?vue&type=script&lang=js"
export * from "./SysRed.vue?vue&type=script&lang=js"

import "./SysRed.vue?vue&type=style&index=0&id=0adf7583&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adf7583"]])

export default __exports__